module.exports = __webpack_public_path__ + "assets/img/block-left-hover-9e5f57cf.png";